import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Notifications.css';
import NotificationDialog from './NotificationDialog';
import NotificationsConstants from '../../redux/constants/NotificationsConstants';

/**
 * ## Redux imports
 */
import * as globalActions from '../../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';
import NotificationErrorDialog from './NotificationErrorDialog';
import Dictionary from '../../model/Dictionary';

class ShuttleBooking extends Component {
  static propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.object,
  };

  state = { open: false };

  componentDidCatch (error) {
    console.error('Component did catch error: ', error);
  }

  componentWillReceiveProps (props) {
    const { notifications } = props;
    if (notifications && notifications.length) {
      let error = notifications.find(
        notification => notification.type === NotificationsConstants.NOTIFICATION_ERROR
      );
      if (error && document) {
        if (document.body) {
          document.body.classList.add('mobile-error-open');
        }
      }
      this.setState({ open: true });
    }
  }

  closeNotification = (notification, isError) => {
    this.props.actions.dismissNotification(notification);
    if (isError && document) {
      if (document.body) {
        document.body.classList.remove('mobile-error-open');
      }
    }
  };

  defaultTitle = type => {
    switch (type) {
      case NotificationsConstants.NOTIFICATION_INFO:
        return Dictionary.notifications.infoTitle;
      case NotificationsConstants.NOTIFICATION_SUCCESS:
        return Dictionary.notifications.successTitle;
      case NotificationsConstants.NOTIFICATION_ERROR:
        return Dictionary.notifications.errorTitle;
      case NotificationsConstants.NOTIFICATION_WARNING:
        return Dictionary.notifications.warningTitle;
      default:
        return Dictionary.notifications.infoTitle;
    }
  };

  render () {
    const { open } = this.state;
    let notifications = this.props.notifications;

    if (!notifications || !notifications.length) return null;

    let notificationError = notifications.find(
      notification => notification.type === NotificationsConstants.NOTIFICATION_ERROR
    );

    if (notificationError) {
      return (
        <NotificationErrorDialog
          key={`notification-${notificationError.type}`}
          notification={notificationError}
          defaultTitle={this.defaultTitle(notificationError.type)}
          handleClose={() => this.closeNotification(notificationError, true)}
          open={open}
        />
      );
    }

    let notificationWarning = notifications.find(
      notification => notification.type === NotificationsConstants.NOTIFICATION_WARNING
    );

    if (notificationWarning) {
      return (
        <NotificationDialog
          key={`notification-${notificationWarning.type}`}
          notification={notificationWarning}
          defaultTitle={this.defaultTitle(notificationWarning.type)}
          handleClose={() => this.closeNotification(notificationWarning)}
          open={open}
        />
      );
    }

    let notificationSuccess = notifications.find(
      notification => notification.type === NotificationsConstants.NOTIFICATION_SUCCESS
    );
    if (notificationSuccess) {
      let dismissNotification = () => this.closeNotification(notificationSuccess);
      setTimeout(function () {
        dismissNotification();
      }, 5000);
      return (
        <NotificationDialog
          key={`notification-${notificationSuccess.type}`}
          notification={notificationSuccess}
          defaultTitle={this.defaultTitle(notificationSuccess.type)}
          url={notificationSuccess.url}
          handleClose={() => this.closeNotification(notificationSuccess)}
          open={open}
        />
      );
    }

    let notificationInfo = notifications.find(
      notification => notification.type === NotificationsConstants.NOTIFICATION_INFO
    );
    if (notificationInfo) {
      return (
        <NotificationDialog
          key={`notification-${notificationInfo.type}`}
          notification={notificationInfo}
          defaultTitle={this.defaultTitle(notificationInfo.type)}
          handleClose={() => this.closeNotification(notificationInfo)}
          open={open}
        />
      );
    }

    return (
      <div>
        {/* show only first notification - to get transition for every other notification */}
        <NotificationDialog
          key={`notification-${notifications[ 0 ].type}-active-notification`}
          notification={notifications[ 0 ]}
          defaultTitle={this.defaultTitle(notifications[ 0 ].type)}
          handleClose={() => this.closeNotification(notifications[ 0 ])}
          open={open}
        />
        {/* {notifications.map((notification, index) => (
          <NotificationDialog
            key={`notification-${notification.type}-${index}`}
            notification={notification}
            defaultTitle={this.defaultTitle(notification.type)}
            handleClose={() => this.closeNotification(notification)}
            open={open}
          />
        ))} */}
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions ];

function mapStateToProps (state) {
  return { notifications: selectors.global.getNotifications(state.global) };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShuttleBooking);



// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.js